console.log(global.Promise.resolve() instanceof Promise)
